import { Sender } from 'xstate';
import asyncCallback from '../../../framework/logic/utils/asyncCallback';

export const useInterval = () =>
  asyncCallback(
    async (
      callback: Sender<{
        type: 'INTERVAL_60S';
      }>
    ) => {
      const intervalId = setInterval(async () => {
        callback({
          type: 'INTERVAL_60S',
        });
      }, 60000);
      return () => {
        if (intervalId) {
          clearInterval(intervalId);
        }
      };
    }
  );
